import { buildModelManager } from "../builder.js";
const DefaultPropertyAccessScopeSelection = {
  __typename: true,
  id: true,
  consentRecord: true,
  createdAt: true,
  delegationParentAccessId: true,
  expiresAt: true,
  grantedAt: true,
  grantedById: true,
  parentGrantId: true,
  propertyAccessId: true,
  requestedAt: true,
  requestedById: true,
  revokedAt: true,
  revokedById: true,
  scopeKey: true,
  suspendedAt: true,
  updatedAt: true
};
const modelApiIdentifier = "propertyAccessScope";
const pluralModelApiIdentifier = "propertyAccessScopes";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessScopeSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPropertyAccessScope",
    operationReturnType: "CreatePropertyAccessScope",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      propertyAccessScope: { required: false, type: "CreatePropertyAccessScopeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePropertyAccessScopes",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreatePropertyAccessScopesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "updatePropertyAccessScope",
    operationReturnType: "UpdatePropertyAccessScope",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccessScope: { required: false, type: "UpdatePropertyAccessScopeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePropertyAccessScopes",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdatePropertyAccessScopesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "approvePropertyAccessScope",
    operationReturnType: "ApprovePropertyAccessScope",
    functionName: "approve",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccessScope: { required: false, type: "ApprovePropertyAccessScopeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "bulkApprovePropertyAccessScopes",
    functionName: "bulkApprove",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "approve",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkApprovePropertyAccessScopesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "revokePropertyAccessScope",
    operationReturnType: "RevokePropertyAccessScope",
    functionName: "revoke",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccessScope: { required: false, type: "RevokePropertyAccessScopeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "bulkRevokePropertyAccessScopes",
    functionName: "bulkRevoke",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "revoke",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRevokePropertyAccessScopesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "upsertPropertyAccessScope",
    operationReturnType: "UpsertPropertyAccessScope",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      propertyAccessScope: { required: false, type: "UpsertPropertyAccessScopeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePropertyAccessScopeResult": { hasReturnType: false },
      "... on UpdatePropertyAccessScopeResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPropertyAccessScopes",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertPropertyAccessScopesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPropertyAccessScopeSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "propertyAccessScopeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PropertyAccessScopeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPropertyAccessScopeSelection,
  operations
);
export {
  DefaultPropertyAccessScopeSelection,
  PropertyAccessScopeManager
};
//# sourceMappingURL=PropertyAccessScope.js.map
